import gql from 'graphql-tag';

export const DELETE_TRACKED_PROPERTY = gql`
    mutation deleteTrackedProperty($uprn: String) {
        deleteTrackedProperty(uprn: $uprn)
    }
`;
